<template>
	<AppDialog :dialogName="dialogName" width="620">
		<div class="create-group py-4 px-16">
			<div class="top py-4">
				<div class="title">{{ title }}</div>
				<AppTextField class="input mt-1" outlined dense v-model="groupName" hide-details single-line :placeholder="defaultGroupName" />
			</div>
			<div class="px-4 group-body">
				<GroupUsePermission @selected-use-permission-type="onUsePermissionChange" :group="group" />
				<GroupPermittedUses @selected-permitted-use="onPermittedUseChange" :group="group" />
			</div>
			<div class="button pt-4 flex-centerize">
				<PrimaryButton :disabled="!canUpdate" @click="create">{{ btnText }}</PrimaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';

import AppDialog from './AppDialog/AppDialog';
import AppDialogManagerService from './AppDialogManager/app-dialog-manager-service';
import GroupUsePermission from '@/views/settings/groups/tabs/SyncedGroupPermissions/GroupUsePermission';
import GroupPermittedUses from '@/views/settings/groups/tabs/SyncedGroupPermissions/GroupPermittedUses';

import { createGroup } from '@/store/modules/accountGroups/actions';
import { groups, defaultGroupName } from '@/store/modules/accountGroups/getters';
export default {
	name: 'ManualGroupDialog',
	components: {
		AppDialog,
		GroupUsePermission,
		GroupPermittedUses,
	},
	props: {
		isUpdate: { type: Boolean, default: false },
		group: { type: Object, default: null },
		parent: { type: Number, default: null },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		...mapGettersShorthand({ groups, defaultGroupName }),
		canUpdate() {
			return this.isUpdate ? !!this.groupName && this.didChange : true;
		},
		title() {
			return this.isUpdate ? `Update ${this.groupType}` : `New ${this.groupType}`;
		},
		groupType() {
			return this.parent ? 'sub group' : 'group';
		},
		btnText() {
			return this.isUpdate ? 'Update' : 'Create';
		},
		didChange() {
			return !this.didUsePermissionChange && !this.didPermittedUseChange;
		},
		didUsePermissionChange() {
			return this.usePermissionType !== this.group.access_type;
		},
		didPermittedUseChange() {
			return Object.keys(this.permittedUse).some((key) => this.permittedUse[key] != this.group.usage_preferences[key]);
		},
	},
	methods: {
		...mapActionsShorthand({ createGroup }),
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		onUsePermissionChange(newV) {
			this.usePermissionType = newV;
		},
		onPermittedUseChange(newV) {
			this.permittedUse = newV;
		},
		async create() {
			const group = {
				access_type: this.usePermissionType,
				usage_preferences: this.permittedUse,
			};
			if (this.isUpdate && this.groupName) {
				this.updateGroup({ name: this.groupName, ...group });
			} else {
				this.createGroup({ name: this.groupName || this.defaultGroupName, type: 'manual', parent: this.parent, ...group });
			}
			this.close();
		},
	},
	mounted() {
		if (this.group) {
			this.groupName = this.group.name;
			this.usePermissionType = this.group.access_type;
			this.permittedUse = { ...this.group.usage_preferences };
		}
	},
	data() {
		return {
			dialogName: 'ManualGroupDialog',
			groupName: '',
			usePermissionType: undefined,
			permittedUse: {},
		};
	},
};
</script>

<style scoped lang="scss">
.create-group {
	height: 500px;
	.group-body {
		height: 300px;
	}
	.title {
		font-weight: 600;
		font-size: x-large;
	}
	.sub-title {
		font-size: small;
	}
	.next-btn {
		background-color: var(--forth-color);
		color: white;
		border-radius: 3px;
	}
}
</style>
